<template>
  <div id="accordionNotification" class="accordion">
    <div class="case-details accordion-item">
      <h2 id="headingNotification" class="accordion-header">
        <button
          aria-controls="collapseNotification"
          aria-expanded="true"
          class="accordion-button collapsed"
          data-bs-target="#collapseNotification"
          data-bs-toggle="collapse"
          type="button"
        >
          <div class="mb-0 d-flex align-items-center">
            <div class="bg-primary rounded-xs me-8 d-flex align-items-center justify-content-center" style="width: 24px; height: 24px; flex: none;">
              <v-icon icon="mail" size="xs" class="text-white" />
            </div>

            <div>
              <div class="h6 ff-secondary mb-0 fw-bold">{{ $t("clientTour.sendNotification") }}</div>
              <div class="fw-light accordion-subtitle text-xs" style="font-size: 10px !important;">{{ $t("clientTour.sendNotificationSubtitle") }}</div>
            </div>
          </div>
        </button>
      </h2>

      <div
        id="collapseNotification"
        aria-labelledby="headingNotification"
        class="accordion-collapse collapse show"
        data-bs-parent="#accordionNotification"
      >
        <div class="accordion-body pb-16 pb-xl-24">
          <form id="case-update-notification-form" class="d-flex flex-column justify-content-between h-100 mb-12">
            <fieldset class="mb-12">
              <legend class="visually-hidden">{{ $t("clientTour.notification") }}</legend>

              <div class="mb-12">
                <v-form-input-radio
                  v-model="paxs"
                  :formValueOptions="[
                    { key: false, label: $t('clientTour.sendOnlyClient') },
                    { key: true, label: $t('clientTour.sendClientAndPaxs') },
                  ]"
                  form-class="mb-4"
                />
              </div>

              <v-form id="case-type-notification-select" :label="$t('clientTour.notification')" form-type="outline" class="mb-0">
                <v-select
                  v-model="notification"
                  :clearable="false"
                  :options="clientEmailNotificationOptions"
                  :reduce="(returnValue: any) => returnValue.key"
                >
                  <template v-slot:no-options>
                    <div class="my-4">{{ $t("general.vueSelect.noOptions") }}</div>
                  </template>
                </v-select>
              </v-form>
            </fieldset>

            <v-button
              :disabled="disableButton"
              :is-loading="disableButton"
              class="btn-icon w-fit align-self-end"
              size="xs"
              variant="primary"
              @click="sendNotification"
            >
              {{ $t("general.button.send") }}
              <v-icon icon="arrow-right" size="xs" space="ms-8" />
            </v-button>
          </form>

          <div class="d-flex flex-column text-xs">
            <div class="d-none d-md-flex d-lg-none d-xl-block">
              <p class="text-xs fw-bold text-uppercase text-muted mb-8">{{ $t("clientTour.clientNotificationLog") }}</p>

              <div class="table-notifications table-responsive pe-8">
                <v-table class="mb-0">
                  <v-table-header>
                    <tr class="text-normal">
                      <th class="text-xs">
                        {{ $t("general.shared.type") }}
                      </th>

                      <th class="text-xs">
                        {{ $t("general.shared.date") }}
                      </th>

                      <th class="text-xs">
                        {{ $t("general.shared.status") }}
                      </th>
                    </tr>
                  </v-table-header>

                  <v-table-body class="fw-medium">
                    <tr v-if="!notificationsLoaded">
                      <td class="position-relative border-0 py-96" colspan="2222">
                        <v-loader />
                      </td>
                    </tr>

                    <template v-else-if="!!notifications && notifications.length > 0">
                      <tr v-for="notification in notifications" :key="notification.id">
                        <td class="text-nowrap">
                          {{ notification.email_type || notification.type || '—' }}
                        </td>

                        <td class="text-nowrap">
                          {{ $str.formatDateTime(notification.created_at, settings.formatDatetime) }}
                        </td>

                        <td class="text-nowrap">
                          <span class="badge bg-success">Sent</span>
                        </td>
                      </tr>
                    </template>

                    <template v-else>
                      <tr>
                        <td class="rounded-xs py-16 text-center text-muted italic" colspan="2222">
                          {{ $t("clientTour.noClientNotifications") }}
                        </td>
                      </tr>
                    </template>
                  </v-table-body>
                </v-table>
              </div>
            </div>

            <div class="item-cards d-block d-md-none d-lg-block d-xl-none mt-8">
              <div v-if="!notificationsLoaded" class="position-relative py-96">
                <v-loader />
              </div>

              <template v-else-if="!!notifications && notifications.length > 0">
                <div id="accordionSetupClientNotification" class="accordion">
                  <div class="case-details accordion-item">
                    <div id="headingSetupClientNotification" class="accordion-header">
                      <button
                        aria-controls="collapseSetupClientNotification"
                        aria-expanded="false"
                        class="accordion-button collapsed fw-semi text-normal"
                        data-bs-target="#collapseSetupClientNotification"
                        data-bs-toggle="collapse"
                        type="button"
                      >
                        {{ $t("clientTour.clientNotificationLog") }}
                      </button>
                    </div>

                    <div
                      id="collapseSetupClientNotification"
                      aria-labelledby="headingSetupClientNotification"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionSetupClientNotification"
                    >
                      <div class="accordion-body pb-16 pb-xl-24">
                        <div
                          v-for="notification in notifications"
                          :key="notification.id"
                          class="item-card border rounded-xs p-8 mb-8"
                        >
                          <div>
                            <span class="fw-medium">{{ $t("general.shared.type") }}: </span>

                            <span>
                              {{ notification.email_type || notification.type || '—' }}
                            </span>
                          </div>

                          <div>
                            <span class="fw-medium">{{ $t("general.shared.date") }}: </span>
                            <span>{{ $str.formatDateTime(notification.created_at, settings.formatDatetime) }}</span>
                          </div>

                          <div>
                            <span class="fw-medium">{{ $t("general.shared.status") }}: </span>
                            <span class="badge bg-success">Sent</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div v-else class="text-center text-muted italic">
                {{ $t("clientTour.noClientNotifications") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import vSelect from "vue-select";
import { VForm, VFormInputRadio } from "@uniqoders/form";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import api from "@/api";
import { findConceptByKey, mapConcepts } from "@/helpers/ConceptHelper";
import useConcepts from "@/helpers/Concepts";
import VTableBody from "@/components/vendor/basic/table/VTableBody.vue";
import VTable from "@/components/vendor/basic/table/VTable.vue";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import VTableHeader from "@/components/vendor/basic/table/VTableHeader.vue";
import Notification from "@/api/objects/Notification";
import { useAppStore } from "@/stores/app";
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  agency: string;
  tour: number;
  clientTour: number;
  clientNotificationLogs?: any[];
}>();

const { concepts } = useConcepts();
const appStore = useAppStore();

const settings = computed(() => appStore.settings);

const clientEmailNotificationOptions = computed(() => {
  if (concepts.value && concepts.value["client.email_notification_types"]) {
    return mapConcepts(concepts.value["client.email_notification_types"]);
  }
  return [];
});

const disableButton = ref(false);
const notification = ref("");
const paxs = ref(false);
const notifications = ref<Notification[]>([]);
const notificationsLoaded = ref(false);
const { t } = useI18n();
const toast = useToast();
const instance = getCurrentInstance();
const $modal = instance?.appContext.config.globalProperties.$modal;

onMounted(async () => {
  notification.value = clientEmailNotificationOptions.value[0]?.key ?? "";
  await loadTourNotifications();
});

const sendNotification = async () => {
  await $modal?.confirm({
    title: t("clientTour.emailModal.title"),
    text: t("clientTour.emailModal.text"),
    leftButtonClasses: "btn-tertiary",
    confirmButtonText: t("general.button.send"),
    confirmButtonCallback: () => doSendNotification(),
  });
};

const doSendNotification = async () => {
  try {
    disableButton.value = true;

    const data = {
      notification: notification.value,
      paxs: paxs.value,
    };

    await api.notification.client(props.agency, props.clientTour, props.tour, data);

    toast.success(t("general.shared.savedChanges"));
  } catch (e: any) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Unexpected error");
  } finally {
    disableButton.value = false;
    await loadTourNotifications();
  }
};

const loadTourNotifications = async () => {
  notifications.value = props.clientNotificationLogs || [];
  notificationsLoaded.value = true;
};
</script>

<style lang="scss" scoped>
.accordion-button,
.accordion-button:not(.collapsed) {
  background-color: transparent;
  padding: 0.5rem 1rem !important;
}

.table-notifications {
  overflow: auto;
  max-height: 23rem;

  thead th {
    background-color: var(--uq-body-bg);
  }
}

.table-notifications thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
